import { render } from "./optionsDropdowIndexComponent.vue?vue&type=template&id=527cfb83&scoped=true"
import script from "./optionsDropdowIndexComponent.vue?vue&type=script&lang=js"
export * from "./optionsDropdowIndexComponent.vue?vue&type=script&lang=js"

import "./optionsDropdowIndexComponent.vue?vue&type=style&index=0&id=527cfb83&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527cfb83"]])

export default __exports__